import Vue from 'vue'
import Router from 'vue-router'

//页面
import index from '@/router/index'
import popu from '@/router/popu'        //实时人口数据包
import cty from '@/router/cty'          //城市体检数据包
import opn from '@/router/opn'          //地区事件和民众口碑数据包
import cbd from '@/router/cbd'          //商圈画像数据包
import space from '@/router/space'      //区域空间改造评估数据包
import visual from '@/router/visual'    //区县决策辅助数据可视化系统

Vue.use(Router)

export default new Router({
    routes: [
        {
            path: '/',
            component: index
        },
        {
            path: '/popu',
            component: popu
        },
        {
            path: '/cty',
            component: cty
        },
        {
            path: '/opn',
            component: opn
        },
        {
            path: '/cbd',
            component: cbd
        },
        {
            path: '/space',
            component: space
        },
        {
            path: '/visual',
            component: visual
        }
    ]
})



// WEBPACK FOOTER //
// ./src/router/router.js